import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toPlural' })
export class ToPluralPipe implements PipeTransform {
  public transform(s: string): string {
    return s.charAt(s.length - 1) === 's' ? s + 'es' : s + 's';
  }
}
